import { useProgram, useWorkflows } from '@cibo/programs'
import { Alert, Button } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export const EnrollmentWindowAlert = ({
  setEnrollmentClosedModalOpen,
}: {
  setEnrollmentClosedModalOpen: Dispatch<SetStateAction<boolean>>
}) => {
  const { t } = useTranslation('impact/pages/ProgramDetailLayout')
  const { programId } = useParams()

  const program = useProgram({ programId })
  const enrollments = useWorkflows(0, 1, { benchmark: ['enrollment'], programId })

  return program.data?.enrollmentWindow.enrollmentStatus === 'closed' ? (
    <Alert
      severity="warning"
      action={
        enrollments.data?.numItems && enrollments.data?.numItems > 0 ? (
          <Button onClick={() => setEnrollmentClosedModalOpen(true)} color="warning">
            {t('removeEnrollments', { count: enrollments.data?.numItems })}
          </Button>
        ) : null
      }
    >
      {!!program.data.enrollmentWindow.enrollmentEnd
        ? t('programClosedEnrollmentEndMd', {
            enrollmentEnd: new Date(program.data.enrollmentWindow.enrollmentEnd),
          })
        : t('programClosedMd')}
    </Alert>
  ) : program.data?.enrollmentWindow.enrollmentStatus === 'future' ? (
    <Alert severity="info">
      {!!program.data.enrollmentWindow.enrollmentStart
        ? t('programFutureEnrollmentStartMd', {
            enrollmentStart: new Date(program.data.enrollmentWindow.enrollmentStart),
          })
        : t('programFutureMd')}
    </Alert>
  ) : null
}
